import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '../auth/AuthContext'

// With AppShell owning the sidebar (admin routes each have their own
// sidebar entry now), AdminLayout is just a role-guard passthrough for
// every /admin/* route. Non-admins get bounced to Control Tower.
export default function AdminLayout() {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (!user.roles.includes('admin')) return <Navigate to="/" replace />
  return <Outlet />
}
